import React from 'react';
import { AttachFileActionButton } from '../../../../components/UI-Elements/FileUpload/AttachFileScreen/AttachFileActionButton';
import { comment } from '@sp-types/FutureOrderType';
import { Product } from '@sp-types/productType';
import ButtonDesigned from '../../../../components/UI-Elements/Buttons/ButtonDesigned';

interface Props {
  accountId: string;
  product: Product;
  setEditedProduct: (_product: Product) => void;
  onSubmitFile: (_filePaths: string[], _comments: comment[]) => void;
  onActionButton: () => void;
  onCancelFile: () => void;
}

export const AddNewProductAttachFile: React.FC<Props> = ({
  accountId,
  product,
  setEditedProduct,
  onActionButton,
  onCancelFile,
  onSubmitFile,
}) => {
  const savingLocation = `products/${accountId}/`;
  const [comments, setComments] = React.useState<comment[]>([]);

  return (
    <div className=" flex-1 overflow-hidden px-11 pt-3 my-3">
      <div className="flex flex-col gap-2">
        <p className="text-xl">Create product</p>
        <p className="text-sm text-gray-700"></p>
      </div>
      <AttachFileActionButton
        bucketSaveLocation={savingLocation}
        handleActionButton={onActionButton}
        handleSubmitWithFilePath={(files: string[]) => onSubmitFile(files, comments)}
        handleCancelSubmit={onCancelFile}
        actionButtonTitle="Create a product"
        actionButtonText="Click to create a new product"
        onCommentsChanged={setComments}
        onFilesChanged={(filesUrl: string[]) => setEditedProduct({ ...product, filesUrl })}
        comments={comments}
        uploadedFiles={product.filesUrl || []}
      />
      {(product.filesUrl || []).length > 0 && (
        <div className="flex flex-1 justify-between sticky bottom-0 bg-white ">
          <ButtonDesigned className="px-4" style="outline" onButtonClick={onCancelFile}>
            Cancel
          </ButtonDesigned>
          <ButtonDesigned
            className="px-4"
            style="primary"
            onButtonClick={() => onSubmitFile(product.filesUrl, comments)}
          >
            Submit
          </ButtonDesigned>
        </div>
      )}
    </div>
  );
};
